export class StudentEngagementData {
  engagementId: number;
  studentId: number;
  serviceId: number;
  startDate: Date;
  endDate: Date;
  frequencyTypeId: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export class UpdateStudentEngagementData {
  engagementId: number;
  studentId: number;
  serviceId: number;
  startDate: Date;
  endDate: Date;
  frequencyTypeId: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export class HistoricStudentEngagementData {
  engagementId: number;
  studentId: number;
  serviceDescrption: string;
  startDate: Date;
  endDate: Date;
  frequencyDescription: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}
